import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAuthInitializer } from './core/auth/providers/auth-initializer.provider';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { API_BASE_URL } from './core/services/api.config';
import { environment } from '../environments/environment.generated';

const apiBaseUrl = environment.apiBaseUrl;

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAuthInitializer(),
    {
      provide: API_BASE_URL,
      useValue: apiBaseUrl,
    },
  ],
};
